import { Theme } from 'features/ui/types'

export const getThemeFromLocalStorage = () => {
  const displayTheme = localStorage.getItem('displayTheme')
  return (displayTheme || 'dark') as Theme
}

export const setThemeToLocalStorage = (theme: Theme) => {
  localStorage.setItem('displayTheme', theme)
}

export const getLabelsIsReadFromLocalStorage = () => {
  const labelsIntroductionTooltip = localStorage.getItem('labelsIsRead')
  return Boolean(labelsIntroductionTooltip) || false
}

export const getSidePanelIsReadFromLocalStorage = () => {
  const sidePannelIntroductionTooltip = localStorage.getItem('sidePanelIsRead')
  return Boolean(sidePannelIntroductionTooltip) || false
}

export const setIntroductionTooltipToLocalStorage = ({
  storageKey,
  isRead
}: {
  storageKey: string
  isRead: boolean
}) => {
  if (isRead) {
    localStorage.setItem(storageKey, 'true')
  } else {
    localStorage.removeItem(storageKey)
  }
}
